export default {
  'startProcessInstance.startMappings': 'Start mappings',
  'startProcessInstance.responseMappings': 'Response mappings',
  'startProcessInstance.mapping': 'Mapping',
  'startProcessInstance.addMapping': 'Add mapping',

  'startProcessInstance.form.select.InstanceName': 'Request - Name',
  'startProcessInstance.form.select.InstanceIdentifier': 'Request - Internal Identifier',
  'startProcessInstance.form.select.InstanceDetailsViewUrl': 'Request - Details View Url',
};
